'use client';

import { useState, useEffect } from 'react';
import { useRegionalFormatters } from '@/lib/use-regional-formatters';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { X } from 'lucide-react';

export function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 800 && !isDismissed) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (isDismissed) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-green-600 px-4 sm:px-6 py-3 sm:py-4 shadow-2xl">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <div className="flex-1 text-center sm:text-left">
            <p className="text-white font-bold text-base sm:text-lg">
              Ready to protect your PostgreSQL data?
            </p>
            <p className="text-blue-100 text-xs sm:text-sm hidden sm:block">
              Start your free trial today — no credit card required
            </p>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <Button
              size="lg"
              className="bg-white text-blue-600 hover:bg-blue-50 font-bold h-10 sm:h-12 px-6 sm:px-8 flex-1 sm:flex-none text-sm sm:text-base"
              asChild
            >
              <Link href="/signup">Start Free Trial</Link>
            </Button>
            <button
              onClick={() => setIsDismissed(true)}
              className="text-white hover:text-blue-100 p-2 flex-shrink-0"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
